import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "../chunks/tslib.es6.js";
import { isSome as t } from "../core/maybe.js";
import { property as e } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as r } from "../core/accessorSupport/decorators/enumeration.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";
import s from "./Symbol3DLayer.js";
import p from "./support/ObjectSymbol3DLayerResource.js";
import { Symbol3DAnchorPosition3D as a } from "./support/Symbol3DAnchorPosition3D.js";
import h from "./support/Symbol3DMaterial.js";

var _n;

var c = _n = /*#__PURE__*/function (_s) {
  _inherits(n, _s);

  var _super = _createSuper(n);

  function n(o) {
    var _this;

    _classCallCheck(this, n);

    _this = _super.call(this, o), _this.material = null, _this.castShadows = !0, _this.resource = null, _this.type = "object", _this.width = void 0, _this.height = void 0, _this.depth = void 0, _this.anchor = void 0, _this.anchorPosition = void 0, _this.heading = void 0, _this.tilt = void 0, _this.roll = void 0;
    return _this;
  }

  _createClass(n, [{
    key: "clone",
    value: function clone() {
      return new _n({
        heading: this.heading,
        tilt: this.tilt,
        roll: this.roll,
        anchor: this.anchor,
        anchorPosition: this.anchorPosition && this.anchorPosition.clone(),
        depth: this.depth,
        enabled: this.enabled,
        height: this.height,
        material: t(this.material) ? this.material.clone() : null,
        castShadows: this.castShadows,
        resource: this.resource && this.resource.clone(),
        width: this.width
      });
    }
  }, {
    key: "isPrimitive",
    get: function get() {
      return !this.resource || "string" != typeof this.resource.href;
    }
  }]);

  return n;
}(s);

o([e({
  type: h,
  json: {
    write: !0
  }
})], c.prototype, "material", void 0), o([e({
  type: Boolean,
  nonNullable: !0,
  json: {
    write: !0,
    default: !0
  }
})], c.prototype, "castShadows", void 0), o([e({
  type: p,
  json: {
    write: !0
  }
})], c.prototype, "resource", void 0), o([r({
  Object: "object"
}, {
  readOnly: !0
})], c.prototype, "type", void 0), o([e({
  type: Number,
  json: {
    write: !0
  }
})], c.prototype, "width", void 0), o([e({
  type: Number,
  json: {
    write: !0
  }
})], c.prototype, "height", void 0), o([e({
  type: Number,
  json: {
    write: !0
  }
})], c.prototype, "depth", void 0), o([r({
  center: "center",
  top: "top",
  bottom: "bottom",
  origin: "origin",
  relative: "relative"
}), e({
  json: {
    default: "origin"
  }
})], c.prototype, "anchor", void 0), o([e({
  type: a,
  json: {
    type: [Number],
    read: {
      reader: function reader(o) {
        return new a({
          x: o[0],
          y: o[1],
          z: o[2]
        });
      }
    },
    write: {
      writer: function writer(o, t) {
        t.anchorPosition = [o.x, o.y, o.z];
      },
      overridePolicy: function overridePolicy() {
        return {
          enabled: "relative" === this.anchor
        };
      }
    }
  }
})], c.prototype, "anchorPosition", void 0), o([e({
  type: Number,
  json: {
    write: !0
  }
})], c.prototype, "heading", void 0), o([e({
  type: Number,
  json: {
    write: !0
  }
})], c.prototype, "tilt", void 0), o([e({
  type: Number,
  json: {
    write: !0
  }
})], c.prototype, "roll", void 0), o([e({
  readOnly: !0
})], c.prototype, "isPrimitive", null), c = _n = o([i("esri.symbols.ObjectSymbol3DLayer")], c);
var l = c;
export { l as default };